import { EXTERNAL_POINT_OF_SALE, MAISON_TO_FULLNAME, WS_EXTERNAL_BOUTIQUE, WS_EXTERNAL_BOUTIQUE_ALT } from './constants'

export const isRetailer = boutique => {
  return (
    boutique.boutiqueType === EXTERNAL_POINT_OF_SALE &&
    boutique.wholesalerCustomerGroup !== WS_EXTERNAL_BOUTIQUE &&
    boutique.wholesalerCustomerGroup !== WS_EXTERNAL_BOUTIQUE_ALT
  )
}

export const sha256 = async message => {
  // encode as UTF-8
  const msgBuffer = new TextEncoder().encode(message)

  // hash the message
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer)

  // convert ArrayBuffer to Array
  const hashArray = Array.from(new Uint8Array(hashBuffer))

  // convert bytes to hex string
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')

  return hashHex
}

export const validateRecaptcha = recaptchaKey => {
  return new Promise((resolve, reject) => {
    try {
      window.grecaptcha.enterprise.ready(async () => {
        const token = await window.grecaptcha.enterprise.execute(recaptchaKey, { action: 'creatingAppointment' })
        resolve(token)
      })
    } catch (err) {
      reject(new Error('invalid-reCAPTCHA-key'))
    }
  })
}

export const optInEnforced = (countriesConfig, country, maisonId) => {
  const countryConfig = countriesConfig?.find(c => c.iso2Code === country)

  if (!countryConfig) {
    return false
  }

  const fullNameMaison = MAISON_TO_FULLNAME[maisonId]
  const optInEnforced = countryConfig.marketingEnforceOptInMaisons
    ?.split(';')
    .find(enforcedMaison => enforcedMaison.toLowerCase() === fullNameMaison?.toLowerCase())

  return !!optInEnforced
}

export const smsEnabled = (countriesConfig, country, maisonId) => {
  const countryConfig = countriesConfig?.find(c => c.name === country)

  if (!countryConfig) {
    return false
  }

  const fullNameMaison = MAISON_TO_FULLNAME[maisonId]
  const smsEnabled = countryConfig.smsEnabledMaisons
    ?.split(';')
    .find(maison => maison.toLowerCase() === fullNameMaison?.toLowerCase())

  return !!smsEnabled
}

export const formatRequiredLabels = (label, locale, required = true) => {
  if (!required) {
    return label
  }

  return locale !== 'ar' ? `${label} *` : `* ${label}`
}
